import React, { useContext, useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';

import { LegislationService } from 'services';
import { FilterButton } from 'components/molecules';
import { HeroImageBackground } from 'components/organisms';
import { LegislationContext } from '../contexts';

const CATEGORIES_MIN_LENGTH = 6;
const CATEGORIES_BUTTON_HEIGHT = 72;

const legislationService = new LegislationService();

const useStyles = makeStyles(theme => ({
  root: {},
}));

const Hero = props => {
  const { className, onChange, ...rest } = props; // eslint-disable-line no-unused-vars
  const classes = useStyles(); // eslint-disable-line no-unused-vars
  const [categories, setCategories] = useState([]);
  const { filters, setFilters } = useContext(LegislationContext);

  useEffect(() => {
    (async () => {
      const { data } = await legislationService.categories();
      setCategories(data);
    })();
  }, []);

  const handleClick = event => {
    setFilters(prev => ({
      ...prev,
      category: event.target.value,
      actYear: undefined,
      act: undefined,
      actPage: 1,
      regYear: undefined,
      regulation: undefined,
      regPage: 1,
    }));
  };

  const heroHeightMobile =
    Math.max(categories?.length || 0, CATEGORIES_MIN_LENGTH) *
      CATEGORIES_BUTTON_HEIGHT +
    40

  const heroHeight = Math.floor(heroHeightMobile / 3) + 56;

  return (
    <HeroImageBackground
      // title={t('HOME_PAGE.LEGISLATION')}
      backgroundImg="assets/images/legislation-cover.jpg"
      backgroundIcon="Legislation/Legislation"
      height={heroHeight}
      mobileHeight={heroHeightMobile}
    >
      <Grid
        container
        spacing={2}
        direction="row"
        justify="space-between"
        alignContent="center"
      >
        {categories.map((category, index) => (
          <Grid item md={4} xs={12} key={index}>
            <FilterButton
              selected={category.id === filters.category}
              title={category.title}
              value={category.id}
              icon={category.icon}
              onClick={handleClick}
            />
          </Grid>
        ))}
      </Grid>
    </HeroImageBackground>
  );
};

Hero.propTypes = {
  /**
   * External classes
   */
  className: PropTypes.string,
};

export default Hero;
